import styled from 'styled-components';

import { theme } from '../layout/theme';

export const HighlightBox = styled.div`
  border: 1px solid ${theme.colors.border.main};

  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  & + & {
    border-top: 0;
  }
`;
